import * as React from 'react';
import {
  RootContext,
  MnInlineMessage,
  UserApiV1TreatmentPath,
  InterviewInstitutionMenuTreatmentPath,
} from '../../../index';

export default class TreatmentCompleteView extends React.Component {
  static contextType = RootContext;

  constructor (props) {
    super(props);

    const interview = [...new URLSearchParams(location.search).entries()].find(item => item[0] === 'interview');
    this.state = { interview: interview && interview[1] === '1' };
  }

  componentDidMount () {
    const ids = location.pathname.split('/').filter(s => s !== '').slice(-2);
    this.context.showLoading();
    this.context.fetch(UserApiV1TreatmentPath(ids[0])).then(body => {
      this.setState({ treatment: body.result });
    }).finally(() => {
      this.context.hideLoading();
    });
  }

  onClickInterview () {
    const ids = location.pathname.split('/').filter(s => s !== '').slice(-6);
    location.href = `${InterviewInstitutionMenuTreatmentPath(ids[0], ids[2], ids[4])}${location.search}`;
  }

  renderCommonComplete () {
    const { t } = this.context;
    return (
      <>
        {this.state.interview ? (
          <MnInlineMessage mode="notice-middle--noicon"
            messages={t('TreatmentCompleteView.input_questionnaire_complete')} class="mx-16px"/>
        ) : null}
        <div className="p-container--content">
          {this.context.formatSimple(this.state?.treatment?.menu?.treatment_flow)}
        </div>
        {this.state?.treatment?.menu?.use_interview === 'using' ? (<div className="m-xl">
          <button className="c-mn-btn--first" onClick={this.onClickInterview}>
            <span>{t('TreatmentCompleteView.input_questionnaire')}</span></button>
          <div className="my-12px">
            <div className="ta-c">{t('TreatmentCompleteView.input_questionnaire_annotation')}</div>
          </div>
        </div>) : null}
      </>
    );
  }

  renderRegionalMedicalCoopComplete () {
    const { t } = this.context;
    return (
      <div className="ta-c">
        {this.context.formatSimple(t('TreatmentCompleteView.regional_medical_cooperation_application_completed'))}
        <br/>
        {this.context.formatSimple(t('TreatmentCompleteView.regional_medical_cooperation_additional_message'))}
      </div>
    );
  }

  render () {
    console.log(this.props);
    const { t } = this.context;
    const isRegionalMedicalCooperation = (this.state?.treatment?.menu?.treatment_category === 'regional_medical_cooperation');
    return (
      <div className="p-container">
        <div className="l-conatiner">
          <h4 className="w90p c-mn-title-2 ta-c">{t('TreatmentCompleteView.title')}</h4>
          {isRegionalMedicalCooperation
            ? this.renderRegionalMedicalCoopComplete() : this.renderCommonComplete()
          }
        </div>
      </div>
    );
  }
}
